// extracted by mini-css-extract-plugin
module.exports = {"marqueeContainer":"styles_marqueeContainer__pREJQ","iconBoxClass":"styles_iconBoxClass__vlUD4"};